import { generateKind } from '@fabric-app/utils/files';
import { isTruthy } from '@fabric-app/utils/guards';
import { Kind } from '@fabric/woody-client';

const getDisplayKind = (resource) => {
  const displayKindFromMime = resource.mimeType ? generateKind(resource.mimeType, resource.extension) : null;
  if (displayKindFromMime) {
    return displayKindFromMime;
  }
  switch (resource.kind) {
    case Kind.BOOKMARK:
      return "Bookmark";
    case Kind.AUDIO:
      return "Audio";
    case Kind.VIDEO:
      return "Video";
    case Kind.FOLDER:
      return "Folder";
    case Kind.NOTEPAD:
      return "Fabric note";
    case Kind.HIGHLIGHT:
      return "Bookmark highlight";
    case Kind.IMAGE:
      return [
        resource.extension?.toUpperCase(),
        "image"
      ].filter(isTruthy).join(" ");
    case Kind.DEFAULT_FILE:
      return [
        resource.extension?.toUpperCase(),
        "file"
      ].filter(isTruthy).join(" ");
    case Kind.DOCUMENT:
      return [
        resource.extension?.toUpperCase(),
        "document"
      ].filter(isTruthy).join(" ");
    case Kind.EMAIL:
      return "Email";
    default:
      return resource.kind;
  }
};

export { getDisplayKind };
//# sourceMappingURL=getDisplayKind.js.map
